import { render, staticRenderFns } from "./Showcase.vue?vue&type=template&id=4022ca5c&scoped=true"
import script from "./Showcase.vue?vue&type=script&lang=js"
export * from "./Showcase.vue?vue&type=script&lang=js"
import style0 from "./Showcase.vue?vue&type=style&index=0&id=4022ca5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4022ca5c",
  null
  
)

export default component.exports